import React from 'react';

const EventsPage = () => {
    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Events</h1>
            <p>Event management functionality will be implemented here.</p>
        </div>
    );
};

export default EventsPage;